import { customRequestStatusNames, CustomRequestStatus } from "@/entities/CustomRequestStatus";

const defaultOptions = Object
  .entries(customRequestStatusNames)
  .filter(([id]) => id !== CustomRequestStatus.RESOLVED)
  .map(([id]) => id);

const customRequestsFiltersTemplate = {
  jobTitle: "",
  skillsIds: [],
  managersIds: [],
  statusIds: defaultOptions,
};

export default customRequestsFiltersTemplate;